import { LanguageCode } from 'enums';

export const LANGUAGES = [
  { code: LanguageCode.English, name: 'English' },
  { code: LanguageCode.Russian, name: 'Русский' },
  { code: LanguageCode.Korean, name: '한국어' },
  { code: LanguageCode.Armenian, name: 'Հայոց լեզու' },
  { code: LanguageCode.Azerbaijani, name: 'Azərbaycan' },
  { code: LanguageCode.Spanish, name: 'Español' },
  { code: LanguageCode.Hindi, name: 'हिन्दी' },
  { code: LanguageCode.Kyrgyz, name: 'Кыргызча' },
  { code: LanguageCode.Kazakh, name: 'Қазақша' },
  { code: LanguageCode.Tajik, name: 'Тоҷикӣ' },
  { code: LanguageCode.Turkish, name: 'Türkçe' },
  { code: LanguageCode.Ukrainian, name: 'Українська' },
  { code: LanguageCode.Uzbek, name: 'Oʻzbekcha' },
  { code: LanguageCode.German, name: 'Deutsch' },
  { code: LanguageCode.French, name: 'Français' },
  { code: LanguageCode.Thai, name: 'ไทย' },
  { code: LanguageCode.Georgian, name: 'ქართული' },
  { code: LanguageCode.Indonesian, name: 'Bahasa Indonesia' },
];

export const LANGUAGE_FLAGS: Record<string, string> = {
  en: 'us',
  hi: 'in',
  idn: 'id',
};
